import { createSlice } from "@reduxjs/toolkit";
import { UserInterface } from "../model/UserInterface";

export interface AuthState {
  status: 'idle' | 'done';
  isLogin: boolean;
  loginUser: UserInterface | null;
  isAdmin: boolean;
}

const initialState: AuthState = {
  status: 'idle',
  isLogin: false,
  loginUser: null,
  isAdmin: false
};

const AuthSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setLogin(state, action) {
      if(action.payload) {
        state.loginUser = action.payload;
        state.isLogin = true;
        state.isAdmin = action.payload.usrAuth === 'A';
      }
      state.status = 'done';
    },
    setLogout(state) {
      state.loginUser = null;
      state.isLogin = false;
    }
  },
  extraReducers: {}
});

export const { setLogin, setLogout } = AuthSlice.actions;
export default AuthSlice;
